import { AlertCircle, Check, X } from "lucide-react";

export default function Toast({ messages, onRemove }) {
  return (
    <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
      {messages.map((t) => (
        <div
          key={t.id}
          className={`flex items-center gap-3 px-4 py-3 rounded-lg shadow-lg text-sm font-medium transition-all duration-300 transform transtone-y-0 opacity-100 ${t.type === "error" ? "bg-red-50 text-red-700 border border-red-200" : "bg-green-50 text-green-700 border border-green-200"}`}
        >
          {t.type === "error" ? (
            <AlertCircle size={18} className="text-red-500" />
          ) : (
            <Check size={18} className="text-green-500" />
          )}
          <span>{t.text}</span>
          <button
            onClick={() => onRemove(t.id)}
            className="ml-auto opacity-70 hover:opacity-100 transition-opacity"
          >
            <X size={16} />
          </button>
        </div>
      ))}
    </div>
  );
}
